var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contact"},[_c('div',{staticClass:"container"},[_c('h1',[_vm._v("ติดต่อเรา")]),_c('div',{staticClass:"contact mt-3"},[_c('div',{staticClass:"column"},[_c('contact-info')],1),_c('div',{staticClass:"column"},[_c('contact-form')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }